import styled, { css } from "styled-components"

export default {
    "Wrapper": styled.div`
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 54px 28px;
        gap: 32px;
    `,

    "RecordList": styled.div`
        display: flex;
        flex-direction: column;
        gap: 16px;
    `,
    "RecordElement": styled.div`    
        display: flex;
        justify-content: space-between;
        gap: 8px;
        padding-bottom: 16px;
        border-bottom: 1px solid ${({ theme }) => theme.color["grey2"]};

        & > div {
            display: flex;
            flex-direction: column;
            gap: 4px;

            & > h2 {
                ${({ theme }) => theme.font["large-semibold"]};
                margin-bottom: 4px;
            }

            & > p {
                ${({ theme }) => theme.font["small-regular"]};
                white-space: nowrap;

                & > span {
                    ${({ theme }) => theme.font["xsmall-semibold"]};
                    color: ${({ theme }) => theme.color["red"]};
                }
            }
        }

        & > button {
            display: flex;
            align-items: center;
            gap: 4px;

            & > p {
                ${({ theme }) => theme.font["xsmall-semibold"]};
                white-space: nowrap;
            }

            & > img {
                height: 8px;
            }
        }
    `,

    "Option": styled.p`
        ${({ theme }) => theme.font["xsmall-medium"]};
    `,
}